var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCheckBadge = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 4h8v8H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6728FF",
    d: "m5.527 15.773-1.382-2.328-2.618-.581.255-2.691L0 8.136 1.782 6.1l-.255-2.69 2.618-.583L5.527.5 8 1.555 10.473.5l1.381 2.327 2.619.582-.255 2.691L16 8.136l-1.782 2.037.255 2.69-2.619.582-1.381 2.328L8 14.718l-2.473 1.055Zm1.71-5.055 4.108-4.109-1.018-1.054-3.09 3.09-1.564-1.527-1.018 1.018 2.581 2.582Z"
  })));
});
SvgCheckBadge.displayName = "SvgCheckBadge";
export default SvgCheckBadge;